import React from 'react';
import { Text } from 'react-native-web';
import SupportServiceWrapper from '../../../modules/SupportServiceWrapper';
import './OpenSupportPageButton.module.scss';

/**
 * Displays a button that opens the support page/widget when clicked
 */
const OpenSupportPageButton = () => (
  <Text
    testID="support-widget-button"
    styleName="openSupportPageButton"
    onClick={() => SupportServiceWrapper.open()}
    tabIndex={0}
  >
    Support
  </Text>
);

export default OpenSupportPageButton;
